import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "srcSet", "sizes", "className"];
var _window;
import React from 'react';
import 'lazysizes';
import ImageWithLoader from './ImageWithLoader';
(_window = window).lazySizesConfig || (_window.lazySizesConfig = {});
window.lazySizesConfig.expand = 300;
window.lazySizesConfig.hFac = 0.667;
window.lazySizesConfig.loadMode = 1;
function LazyImage(_ref) {
  var src = _ref.src,
    srcSet = _ref.srcSet,
    sizes = _ref.sizes,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ImageWithLoader, _extends({
    "data-src": src,
    "data-srcset": srcSet,
    "data-sizes": sizes,
    className: "lazyload ".concat(className ? className : '')
  }, otherProps));
}
export { ImageWithLoader };
export default LazyImage;